<template>
  <b-form-group
    label="Kategori"
    label-for="categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Kategori"
      rules="required"
    >
      <v-select
        id="id_categories"
        v-model="dataItem.id_categories"
        label="title"
        :options="categories"
        :reduce="category => category.id"
        placeholder="Seçiniz"
        :clearable="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CategorySelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    categories() {
      return this.$store.getters['categories/dataList']
    },
  },
  created() {
    localize(this.locale)
    this.getCategories()
  },
  methods: {
    getCategories() {
      this.$store.dispatch('categories/getDataList', {
        select: ['categories.id AS id', 'categories.title AS title'],
      })
    },
  },
}
</script>

<style scoped></style>
